import AppInfo from '../../../app.json';
import './AppVersion.scss';

const AppVersion: React.FC = () => {
  return <div className="app-version">{AppInfo.version}</div>;
};

export default AppVersion;
